type RoomControlState = { phase: string };

const SHARED_LOBBY_ACTIONS = new Set([
  "category", "game_mode", "question_count", "target_score",
  "taboo_team_mode", "taboo_team_assign", "taboo_settings",
  "codenames_team_mode", "codenames_team_assign", "sequence_team_count",
  "poker_settings", "blackjack_settings", "blackjack_count_visibility", "kart_track", "tokyo_settings",
  "ticket_europa_1912_setting", "party_pet_settings", "feud_team_assign",
]);

// Game selection, setup, and completed-game rematches belong to the whole party.
// Live host controls retain their permissions, including resetting a live pet world.
export function canUseRoomControl(state: RoomControlState, action: string, isAdmin: boolean) {
  if (isAdmin) return true;
  if (action === "switch_game") return state.phase === "menu";
  if (action === "party_menu") return ["lobby", "menu", "finished"].includes(state.phase);
  if (state.phase === "lobby" && SHARED_LOBBY_ACTIONS.has(action)) return true;
  if (action === "party_pet_reset") return state.phase === "party_finale";
  return state.phase === "finished" && ["reset", "tokyo_rematch"].includes(action);
}
